import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './companyForm';
import List from './companyList';

const settings = {
    pathRegister: paths.companyRegister,
    pathList: paths.company,
    apiPath: 'company',
    permissionAdmin: null,
    title: 'Empresa',
};

const Company: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const CompanyList: React.FC = () => {
    return (
        <MainContainer>
            <List />
        </MainContainer>
    );
};

export { Company, CompanyList };
